// extracted by mini-css-extract-plugin
export default {"Gallery":"Gallery_Gallery__zi5hG","carousel":"Gallery_carousel__USXDF"};